import { Component, OnInit, Input, ElementRef, Output, EventEmitter, Renderer2 } from '@angular/core';

import { PaginationData, defalutPaginationData } from './pagination';

export interface ChangePaginationEvent {
  page: number;
  itemsPerPage: number;
}

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  private _totalItems: number = 0;

  @Input() itemsPerPage: number = 14;
  @Input() currentPage: number;
  @Output() pageChanged = new EventEmitter<ChangePaginationEvent>();

  pages: number[] = [];

  constructor(
    private elRef: ElementRef,
    protected renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.renderer.setStyle(this.elRef.nativeElement.parentElement, 'padding', '0');
  }

  @Input() set paginationData(pagination: PaginationData) {
    const pd = pagination ? pagination : defalutPaginationData();
    this.itemsPerPage = pd.itemsPerPage;
    this.currentPage = pd.currentPage;
    this._totalItems = pd.totalItems;
  }

  @Input() set totalItems(value: number) {
    this._totalItems = value;
    this.pages = [];
    const numPages = value / this.itemsPerPage;
    for (let i = 1; i <= numPages; i++) {
      this.pages.push(i);
    }
  }

  get totalItems(): number {
    return this._totalItems;
  }

  pageClick(event: ChangePaginationEvent): void {
    if (this.currentPage !== event.page) {
      this.currentPage = event.page;
      this.pageChanged.emit(event);
    }
  }
}
